import {chain} from "@Common/utils/fs";

const {arrMapToO} = require("@Common/utils/objects");

export const getTagPath = (tag) => {
    if (tag.tagName.toUpperCase() === "BODY") {
        return [];
    }
    return [
        ...tag.parentNode && getTagPath(tag.parentNode) ||[],
        {
            tagName: tag.tagName,
            ...chain(
                tag.getAttribute("class"),
                (_) => _ && {
                    className: _,
                },
            ),
            ...chain(
                ["id", "src", "href", "alt"].map((attr) => ({attr, value: tag.getAttribute(attr)})).filter(({value}) => value),
                (_) => arrMapToO(_, ({value}) => value, ({attr}) => attr),
            ),
            ...chain(
                (tag.childNodes && Array.from(tag.childNodes))?.filter((n) => n.nodeType === 3).map((n) => n.textContent).filter(v=>v),
                (_) => _?.length && {
                    texts: _,
                },
            ),
        },
    ];
};
